import { render, staticRenderFns } from "./SuggestionDragList.vue?vue&type=template&id=11024ff8&"
import script from "./SuggestionDragList.vue?vue&type=script&lang=js&"
export * from "./SuggestionDragList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports